import { createContext } from 'react'
import type { PageMetadata } from './page-metadata'

/** Request-scoped SSR collection; never share metadata between visitor requests. */
export interface ServerPageMetadata { current?: PageMetadata }
export const ServerPageMetadataContext = createContext<ServerPageMetadata | null>(null)
